import { absolutePath } from "./absolutePath";

interface PostFollowersFnProps {
  params?: Record<string, unknown>;
  postFollowerId?: string | number;
  postId?: string | number;
}

export const postFollowers = {
  create: ({ postId, params = {} }: PostFollowersFnProps = {}) =>
    absolutePath(`posts/${postId}/post_followers`, params),
  destroy: ({
    postId,
    postFollowerId,
    params = {},
  }: PostFollowersFnProps = {}) =>
    absolutePath(`posts/${postId}/post_followers/${postFollowerId}`, params),
};
